'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var sdk = require('@cognite/sdk');
var sdkCore = require('@cognite/sdk-core');

/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
/* global Reflect, Promise */

var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
    return extendStatics(d, b);
};

function __extends(d, b) {
    if (typeof b !== "function" && b !== null)
        throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    extendStatics(d, b);
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

function __generator(thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
}

function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
}

/** @deprecated */
function __spread() {
    for (var ar = [], i = 0; i < arguments.length; i++)
        ar = ar.concat(__read(arguments[i]));
    return ar;
}

var version="0.35.1";

// Copyright 2023 Cognite AS
var IntegrationsAPI = /** @class */ (function (_super) {
    __extends(IntegrationsAPI, _super);
    function IntegrationsAPI() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.create = function (items) {
            return _this.createEndpoint(items);
        };
        _this.list = function (filter) {
            return _this.listEndpoint(_this.callListEndpointWithPost, filter);
        };
        _this.delete = function (ids) {
            return _this.deleteEndpoint(ids);
        };
        return _this;
    }
    return IntegrationsAPI;
}(sdkCore.BaseResourceAPI));

// Copyright 2024 Cognite AS
var LogsAPI = /** @class */ (function (_super) {
    __extends(LogsAPI, _super);
    function LogsAPI() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * @hidden
     */
    LogsAPI.prototype.getDateProps = function () {
        return this.pickDateProps(['items', 'data'], ['createdTime', 'lastUpdatedTime', 'timestamp']);
    };
    LogsAPI.prototype.retrieve = function (items) {
        return this.retrieveEndpoint(items);
    };
    return LogsAPI;
}(sdkCore.BaseResourceAPI));

// Copyright 2024 Cognite AS
var ModelRevisionsAPI = /** @class */ (function (_super) {
    __extends(ModelRevisionsAPI, _super);
    function ModelRevisionsAPI() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.create = function (items) {
            return _this.createEndpoint(items);
        };
        _this.list = function (filter) {
            return _this.listEndpoint(_this.callListEndpointWithPost, filter);
        };
        _this.update = function (changes) {
            return _this.updateEndpoint(changes);
        };
        _this.delete = function (ids) {
            return _this.deleteEndpoint(ids);
        };
        return _this;
    }
    /**
     * @hidden
     */
    ModelRevisionsAPI.prototype.getDateProps = function () {
        return this.pickDateProps(['items'], ['createdTime', 'lastUpdatedTime']);
    };
    ModelRevisionsAPI.prototype.retrieve = function (items) {
        return this.retrieveEndpoint(items);
    };
    return ModelRevisionsAPI;
}(sdkCore.BaseResourceAPI));

// Copyright 2024 Cognite AS
var ModelsAPI = /** @class */ (function (_super) {
    __extends(ModelsAPI, _super);
    function ModelsAPI() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.create = function (items) {
            return _this.createEndpoint(items);
        };
        _this.aggregate = function (query) {
            return _this.aggregateEndpoint(query);
        };
        _this.list = function (filter) {
            return _this.listEndpoint(_this.callListEndpointWithPost, filter);
        };
        _this.update = function (changes) {
            return _this.updateEndpoint(changes);
        };
        _this.delete = function (ids) {
            return _this.deleteEndpoint(ids);
        };
        return _this;
    }
    /**
     * @hidden
     */
    ModelsAPI.prototype.getDateProps = function () {
        return this.pickDateProps(['items'], ['createdTime', 'lastUpdatedTime']);
    };
    ModelsAPI.prototype.retrieve = function (items) {
        return this.retrieveEndpoint(items);
    };
    return ModelsAPI;
}(sdkCore.BaseResourceAPI));

// Copyright 2024 Cognite AS
var RoutinesAPI = /** @class */ (function (_super) {
    __extends(RoutinesAPI, _super);
    function RoutinesAPI() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.create = function (items) {
            return _this.createEndpoint(items);
        };
        _this.list = function (filter) {
            return _this.listEndpoint(_this.callListEndpointWithPost, filter);
        };
        _this.delete = function (ids) {
            return _this.deleteEndpoint(ids);
        };
        return _this;
    }
    /**
     * @hidden
     */
    RoutinesAPI.prototype.getDateProps = function () {
        return this.pickDateProps(['items'], ['createdTime', 'lastUpdatedTime']);
    };
    return RoutinesAPI;
}(sdkCore.BaseResourceAPI));

// Copyright 2024 Cognite AS
var RoutineRevisionsAPI = /** @class */ (function (_super) {
    __extends(RoutineRevisionsAPI, _super);
    function RoutineRevisionsAPI() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.create = function (items) {
            return _this.createEndpoint(items);
        };
        _this.callRevisionListEndpoint = function (query) { return __awaiter(_this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.post(this.listPostUrl, {
                            data: query || {},
                        })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response];
                }
            });
        }); };
        _this.list = function (query) {
            return _this.cursorBasedEndpoint(_this.callRevisionListEndpoint, query);
        };
        _this.delete = function (ids) {
            return _this.deleteEndpoint(ids);
        };
        return _this;
    }
    /**
     * @hidden
     */
    RoutineRevisionsAPI.prototype.getDateProps = function () {
        return this.pickDateProps(['items'], ['createdTime']);
    };
    RoutineRevisionsAPI.prototype.retrieve = function (items) {
        return this.retrieveEndpoint(items);
    };
    return RoutineRevisionsAPI;
}(sdkCore.BaseResourceAPI));

// Copyright 2023 Cognite AS
var SimulationRunDataAPI = /** @class */ (function (_super) {
    __extends(SimulationRunDataAPI, _super);
    function SimulationRunDataAPI() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.retrieve = function (ids) {
            var path = _this.url('list');
            return _this.retrieveEndpoint(ids, {}, path);
        };
        return _this;
    }
    return SimulationRunDataAPI;
}(sdkCore.BaseResourceAPI));

// Copyright 2023 Cognite AS
var SimulationRunsAPI = /** @class */ (function (_super) {
    __extends(SimulationRunsAPI, _super);
    function SimulationRunsAPI() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.run = function (items) {
            var runUrl = _this.url().slice(0, -2); // `/run` instead of `/runs`
            return _this.createEndpoint(items, runUrl);
        };
        _this.list = function (filter) {
            return _this.listEndpoint(_this.callListEndpointWithPost, filter);
        };
        _this.retrieve = function (ids) {
            var items = ids.map(function (id) { return ({ id: id }); });
            return _this.retrieveEndpoint(items);
        };
        return _this;
    }
    /**
     * @hidden
     */
    SimulationRunsAPI.prototype.getDateProps = function () {
        return this.pickDateProps(['items'], ['createdTime', 'lastUpdatedTime', 'runTime', 'simulationTime']);
    };
    return SimulationRunsAPI;
}(sdkCore.BaseResourceAPI));

var SimulatorsAPI = /** @class */ (function (_super) {
    __extends(SimulatorsAPI, _super);
    function SimulatorsAPI() {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        var _this = _super.apply(this, __spread(args)) || this;
        _this.create = function (items) {
            return _this.createEndpoint(items);
        };
        _this.list = function (filter) {
            return _this.listEndpoint(_this.callListEndpointWithPost, filter);
        };
        _this.update = function (changes) {
            return _this.updateEndpoint(changes);
        };
        _this.delete = function (ids) {
            return _this.deleteEndpoint(ids);
        };
        _this.listIntegrations = function (filter) {
            return _this.integrationsApi.list(filter);
        };
        _this.createIntegrations = function (items) {
            return _this.integrationsApi.create(items);
        };
        _this.deleteIntegrations = function (ids) {
            return _this.integrationsApi.delete(ids);
        };
        _this.listRuns = function (filter) {
            return _this.runsApi.list(filter);
        };
        _this.listRunData = function (ids) {
            return _this.runDataApi.retrieve(ids);
        };
        _this.runSimulation = function (items) {
            return _this.runsApi.run(items);
        };
        _this.retrieveRuns = function (ids) {
            return _this.runsApi.retrieve(ids);
        };
        _this.aggregateModels = function (query) {
            return _this.modelsApi.aggregate(query);
        };
        _this.listModels = function (filter) {
            return _this.modelsApi.list(filter);
        };
        _this.retrieveModels = function (items) {
            return _this.modelsApi.retrieve(items);
        };
        _this.createModels = function (items) {
            return _this.modelsApi.create(items);
        };
        _this.deleteModels = function (ids) {
            return _this.modelsApi.delete(ids);
        };
        _this.updateModels = function (changes) {
            return _this.modelsApi.update(changes);
        };
        _this.listModelRevisions = function (filter) {
            return _this.modelRevisionsApi.list(filter);
        };
        _this.retrieveModelRevisions = function (items) {
            return _this.modelRevisionsApi.retrieve(items);
        };
        _this.createModelRevisions = function (items) {
            return _this.modelRevisionsApi.create(items);
        };
        _this.deleteModelRevisions = function (ids) {
            return _this.modelRevisionsApi.delete(ids);
        };
        _this.updateModelRevisions = function (changes) {
            return _this.modelRevisionsApi.update(changes);
        };
        _this.listRoutines = function (filter) {
            return _this.routinesApi.list(filter);
        };
        _this.createRoutines = function (items) {
            return _this.routinesApi.create(items);
        };
        _this.deleteRoutines = function (ids) {
            return _this.routinesApi.delete(ids);
        };
        _this.listRoutineRevisions = function (filter) {
            return _this.routineRevisionsApi.list(filter);
        };
        _this.retrieveRoutineRevisions = function (items) {
            return _this.routineRevisionsApi.retrieve(items);
        };
        _this.createRoutineRevisions = function (items) {
            return _this.routineRevisionsApi.create(items);
        };
        _this.retrieveLogs = function (items) {
            return _this.logsApi.retrieve(items);
        };
        var _a = __read(args, 3), resourcePath = _a[0], client = _a[1], metadataMap = _a[2];
        _this.integrationsApi = new IntegrationsAPI(resourcePath + "/integrations", client, metadataMap);
        _this.runsApi = new SimulationRunsAPI(resourcePath + "/runs", client, metadataMap);
        _this.runDataApi = new SimulationRunDataAPI(resourcePath + "/runs/data", client, metadataMap);
        _this.modelsApi = new ModelsAPI(resourcePath + "/models", client, metadataMap);
        _this.modelRevisionsApi = new ModelRevisionsAPI(resourcePath + "/models/revisions", client, metadataMap);
        _this.routinesApi = new RoutinesAPI(resourcePath + "/routines", client, metadataMap);
        _this.routineRevisionsApi = new RoutineRevisionsAPI(resourcePath + "/routines/revisions", client, metadataMap);
        _this.logsApi = new LogsAPI(resourcePath + "/logs", client, metadataMap);
        return _this;
    }
    /**
     * @hidden
     */
    SimulatorsAPI.prototype.getDateProps = function () {
        return this.pickDateProps(['items'], ['createdTime', 'lastUpdatedTime']);
    };
    return SimulatorsAPI;
}(sdkCore.BaseResourceAPI));

var CogniteClientAlpha = /** @class */ (function (_super) {
    __extends(CogniteClientAlpha, _super);
    function CogniteClientAlpha() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(CogniteClientAlpha.prototype, "simulators", {
        get: function () {
            return sdkCore.accessApi(this.simulatorsApi);
        },
        enumerable: false,
        configurable: true
    });
    CogniteClientAlpha.prototype.initAPIs = function () {
        _super.prototype.initAPIs.call(this);
        this.httpClient.setDefaultHeader('cdf-version', 'alpha');
        this.simulatorsApi = this.apiFactory(SimulatorsAPI, 'simulators');
    };
    Object.defineProperty(CogniteClientAlpha.prototype, "version", {
        get: function () {
            return version + "-alpha";
        },
        enumerable: false,
        configurable: true
    });
    return CogniteClientAlpha;
}(sdk.CogniteClient));

// Copyright 2020 Cognite AS
var SimulatorIntegrationConnectorStatus = {
    IDLE: 'IDLE',
    RUNNING_SIMULATION: 'RUNNING_SIMULATION',
};
var SimulationRunType = {
    external: 'external',
    manual: 'manual',
    scheduled: 'scheduled',
};
var SimulationRunStatus = {
    ready: 'ready',
    running: 'running',
    success: 'success',
    failure: 'failure',
};
var SimulationRunDataValueType = {
    STRING: 'STRING',
    DOUBLE: 'DOUBLE',
    STRING_ARRAY: 'STRING_ARRAY',
    DOUBLE_ARRAY: 'DOUBLE_ARRAY',
};
var SimulatorLogSeverityLevel = {
    Debug: 'Debug',
    Information: 'Information',
    Warning: 'Warning',
    Error: 'Error',
};
var SimulatorModelRevisionStatus = {
    unknown: 'unknown',
    success: 'success',
    failure: 'failure',
};
var SimulatorRoutineOperator = {
    eq: 'eq',
    ne: 'ne',
    gt: 'gt',
    ge: 'ge',
    lt: 'lt',
    le: 'le',
};
var SimulatorDataPointsAggregate = {
    average: 'average',
    interpolation: 'interpolation',
    stepInterpolation: 'stepInterpolation',
};

Object.keys(sdk).forEach(function (k) {
    if (k !== 'default') Object.defineProperty(exports, k, {
        enumerable: true,
        get: function () {
            return sdk[k];
        }
    });
});
exports.CogniteClientAlpha = CogniteClientAlpha;
exports.SimulationRunDataValueType = SimulationRunDataValueType;
exports.SimulationRunStatus = SimulationRunStatus;
exports.SimulationRunType = SimulationRunType;
exports.SimulatorDataPointsAggregate = SimulatorDataPointsAggregate;
exports.SimulatorIntegrationConnectorStatus = SimulatorIntegrationConnectorStatus;
exports.SimulatorLogSeverityLevel = SimulatorLogSeverityLevel;
exports.SimulatorModelRevisionStatus = SimulatorModelRevisionStatus;
exports.SimulatorRoutineOperator = SimulatorRoutineOperator;
//# sourceMappingURL=index.js.map
